import { ASTGeneratedOutput, Generator } from "@core/services/common/Generator";
import { useOffers } from "../../../../../../../stores/admin/offers/offersStore";

export default function offerGenerator (offerId: string): ASTGeneratedOutput {
  const money = ["value", "currency"];
  let exclude = [] as string[];
  const { isShowCommissions } = useOffers();

  if (!isShowCommissions) {
    exclude = [
      "minimalCommission/value",
      "minimalCommission/currency",
      "advertiserMinimalCommission/value",
      "advertiserMinimalCommission/currency",
      "finance/rate/value",
      "finance/rate/currency",
      "finance/maxAllowedRate/value",
      "finance/maxAllowedRate/currency",
      "finance/minAllowedPayout/value",
      "finance/minAllowedPayout/currency"
    ];
  }

  const params = { exclude };

  const gqlObject = {
    operation: "offer",

    fields: [
      "id",
      "intId",
      "slug",
      "labels",
      "isApiAllowed",
      "vertical",
      "createdAt",
      "isLaunched",
      "type",
      "isLaunched",
      "landingParameters",
      "photoUrl",
      "landingUrl",
      {
        detail: [
          "name",
          "description",
          "rules",
          "isInHouse"
        ]
      },
      {
        finance: [
          { rate: money },
          { payout: money },
          { maxAllowedRate: money },
          { minAllowedPayout: money },
          { minimalCommission: money },
          { holdTime: ["holdMinutes"] },
          "withdrawType",
          "subGoalType",
          "currency",
          "duplicateTimeout"
        ]
      },
      {
        landing: [
          "currency",
          "cost",
          "preCost",
          "trackingPageId"
        ]
      },
      {
        advertiser: [
          "id",
          "intId",
          "login",
          { minimalCommission: money }
        ]
      },
      { categories: ["id"] },
      { logo: ["id", "url"] },
      { previewLogo: ["id", "url"] },
      { countries: ["id"] },
      { trafficTypes: ["id", "name"] },
      { minimalCommission: money },
      { advertiserMinimalCommission: money }
    ],

    variables: {
      offerId: {
        type: "Uid!",
        value: offerId
      }
    }
  };

  return Generator.query(gqlObject, params);
}
